export default "__VITE_PUBLIC_ASSET__9c919faf__"